<script lang="ts">


    import HtmlTitleView from "../../../component/common/Html/HtmlTitleView.svelte";
    import {UrlUtil} from "../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../lib/Common/Http/HttpRequestUtil";
    import LoadingContentView from "../../../component/common/Loading/LoadingContentView.svelte";
    import {EnvStore} from "../../../store/EnvStore";
    import LabelValueView from "../../../component/common/Value/LabelValueView.svelte";
    import BinaryListView from "./Binary/BinaryListView.svelte";
    import InputAreaView from "../../../component/common/Form/InputAreaView.svelte";
    import ButtonView from "../../../component/common/Button/ButtonView.svelte";
    import {BinaryTable} from "../../../lib/Table/BinaryTable";
    import {ObjectUtil} from "../../../lib/Common/Value/ObjectUtil";
    import TagView from "./Binary/Tag/TagView.svelte";
    import {ValueUtil} from "../../../lib/Common/Value/ValueUtil";
    import {SpaceUserTable} from "../../../lib/Table/SpaceUserTable";
    import AppManageView from "./Manage/AppManageView.svelte";
    import BinaryApiHelpView from "./Parts/BinaryApiHelp/BinaryApiHelpView.svelte";
    import {onMount} from "svelte";
    import TipsMessageAreaView from "../../../component/common/Message/TipsMessageAreaView.svelte";
    import InputTextView from "../../../component/common/Form/InputTextView.svelte";
    import SpaceLoadView from "../../../component/Space/SpaceLoadView.svelte";
    import ValueSlotView from "../../../component/common/Value/ValueSlotView.svelte";
    import HeadingTitleView from "../../../component/common/Typography/HeadingTitleView.svelte";

    const ShowTagLimitCount = 20;

    export let params = {};

    $: osType = EnvStore.osType;
    $: isSmartPhone = (() => {
        return EnvStore.isSmartPhone($osType);
    })();

    $: pageTitle = (() => {
        if (space == null) {
            return 'アプリ';
        }
        if (app == null) {
            return space.name;
        }


        return `${app.name} - ${space.name}`;
    })();

    $: tags = (() => {
        if (app == null) {
            return [];
        }
        const tags = app.tags;
        return tags;
    })();


    $: {
        if (space != null) {
            loadData(params);
        }
    }

    let space = null;
    let hasManagerRoll = false;

    let isLoading = false;
    let app = null;


    let filterMap = {};
    let searchFilterMap = {};

    let isShowAllTag = false;

    onMount(() => {
        readUrlParam();
    });

    function onLoadSpace(event) {
        space = event.detail.space;
    }


    function loadData(params) {
        const paramMap = {};
        paramMap['space_id'] = space.id;
        const uniqueId = params['app_unique_id'];
        paramMap['unique_id'] = uniqueId;
        paramMap['include_qr_code_last_generated_user'] = undefined;

        paramMap['include_tags'] = undefined;
        // paramMap['tags_order_by'] = 'use_count:desc,id:desc';
        // paramMap['tags_order_by'] = 'created_at:desc,id:desc';
        paramMap['tags_order_by'] = 'latest_use_at:desc,created_at:desc,id:desc';


        const url = UrlUtil.createApiUrl("app", paramMap);

        isLoading = true;
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];
            const apps = body['apps'];
            if (apps.length > 0) {
                app = apps[0];
            } else {
                app = null;
            }


        });
    }


    function onHashChange(event) {
        readUrlParam();
    }

    function jumpSearchUrl() {

        if (space == null) {
            return;
        }
        if (app == null) {
            return;
        }
        const spaceUniqueId = space.unique_id;
        const appUniqueId = app.unique_id;

        const paramMap = {};

        ObjectUtil.copyKeyValue(filterMap, paramMap, 'binary_name');

        if ('binary_type' in filterMap) {
            const binaryType = filterMap['binary_type'];
            if (binaryType != null) {
                paramMap['binary_type'] = binaryType;
            }
        }
        if ('binary_platform_type' in filterMap) {
            const binaryPlatformType = filterMap['binary_platform_type'];
            if (binaryPlatformType != null) {
                paramMap['binary_platform_type'] = binaryPlatformType;
            }
        }

        ObjectUtil.copyKeyValue(filterMap, paramMap, 'description');

        ObjectUtil.copyKeyValue(filterMap, paramMap, 'binary_tag_names');

        if ('auto_delete_type' in filterMap) {
            const autoDeleteType = filterMap['auto_delete_type'];
            if (autoDeleteType != null) {
                paramMap['auto_delete_type'] = autoDeleteType;
            }
        }

        const url = UrlUtil.createWebUrl(`space/${spaceUniqueId}/app/${appUniqueId}`, paramMap);

        location.assign(url);
    }

    function readUrlParam() {
        const urlParamMap = UrlUtil.createParamMapForCurrentUrl();

        const newFilterMap = {};

        ObjectUtil.copyKeyValue(urlParamMap, newFilterMap, 'binary_name');
        ObjectUtil.copyKeyValue(urlParamMap, newFilterMap, 'binary_type', true);
        ObjectUtil.copyKeyValue(urlParamMap, newFilterMap, 'binary_platform_type', true);
        ObjectUtil.copyKeyValue(urlParamMap, newFilterMap, 'description');
        ObjectUtil.copyKeyValue(urlParamMap, newFilterMap, 'binary_tag_names');
        ObjectUtil.copyKeyValue(urlParamMap, newFilterMap, 'auto_delete_type', true);

        console.log({newFilterMap});

        filterMap = newFilterMap;
        searchFilterMap = {...newFilterMap};
    }

    function onClickQueryTag(event) {
        const tag = event.detail.tag;
        const tagName = tag.name;
        let newTagNames = filterMap['binary_tag_names'];
        if (ValueUtil.isEmpty(newTagNames)) {
            newTagNames = tagName;
        } else {
            newTagNames += ` ${tagName}`;
        }
        filterMap['binary_tag_names'] = newTagNames;
    }

    function onUpdate() {
        loadData(params);
    }

    function onClickShowAllTag() {
        isShowAllTag = true;
    }

</script>

<HtmlTitleView pageTitle={pageTitle}/>
<svelte:window on:hashchange={onHashChange}/>

<div class="app-page standard-page">
    <SpaceLoadView spaceUniqueId={params['space_unique_id']}
                   on:load={onLoadSpace}
                   isShowNotFoundMessage={true}
    >
        <LoadingContentView isLoading={isLoading}>
            <ValueSlotView value={app}>
                <div>
                    <HeadingTitleView title={app.name} backLinkUrl={`/#/space/${params['space_unique_id']}`}>
                        <div slot="right">
                            <BinaryApiHelpView/>
                        </div>
                        <div slot="bottom">
                            <div class="information-area">
                                <LabelValueView label="アプリID" value={app.id}/>
                                <LabelValueView label="アプリユニークID" value={app.unique_id}/>
                                <LabelValueView label="バージョンカウント" value={app.version_count}/>

                            </div>
                        </div>
                    </HeadingTitleView>


                    <div class="query-area">
                        <fieldset>
                            <legend>検索</legend>
                            <div class="query-content">
                                <div class="row">
                                    <InputAreaView label="バイナリ名">
                                        <InputTextView bind:value={filterMap['binary_name']} placeHolder="バイナリ名"
                                                       on:enter={jumpSearchUrl}/>
                                    </InputAreaView>
                                    <InputAreaView label="タイプ" labelMinWidthEm="4">
                                        <select bind:value={filterMap['binary_type']}>
                                            <option value={null}></option>
                                            {#each Object.entries(BinaryTable.Type.map) as [id, name]}
                                                <option value={Number(id)}>{name}</option>
                                            {/each}

                                        </select>
                                    </InputAreaView>
                                    <InputAreaView label="プラットフォーム">
                                        <select bind:value={filterMap['binary_platform_type']}>
                                            <option value={null}></option>
                                            {#each Object.entries(BinaryTable.PlatformType.map) as [id, name]}
                                                <option value={Number(id)}>{name}</option>
                                            {/each}

                                        </select>
                                    </InputAreaView>

                                    <InputAreaView label="自動削除タイプ"
                                                   hoverTipsMessage="古いバイナリは通常自動削除されますが、その保護状態での条件です">
                                        <select bind:value={filterMap['auto_delete_type']}>
                                            <option></option>
                                            {#each Object.entries(BinaryTable.AutoDeleteType.map) as [key, name]}
                                                <option value={Number(key)}>{name}</option>
                                            {/each}
                                        </select>
                                    </InputAreaView>

                                </div>

                                <div class="row">
                                    <InputAreaView label="説明">
                                        <InputTextView bind:value={filterMap['description']}
                                                       placeHolder="説明(あいまい検索)"
                                                       on:enter={jumpSearchUrl}/>
                                    </InputAreaView>
                                </div>

                                <div class="row">
                                    <fieldset>
                                        <legend>タグ</legend>

                                        <div class="tag-names">
                                            <InputAreaView label="タグ名">
                                                <InputTextView bind:value={filterMap['binary_tag_names']}
                                                               placeHolder="タグ(スペースで区切って複数)"
                                                               widthEm="30"
                                                               on:enter={jumpSearchUrl}/>
                                            </InputAreaView>
                                        </div>
                                        <div class="tag-area">
                                            {#each tags as tag, i}
                                                {#if i < ShowTagLimitCount}
                                                    <TagView tag={tag} canClick={true} on:click={onClickQueryTag}/>
                                                {:else}
                                                    {#if isShowAllTag}
                                                        <TagView tag={tag} canClick={true} on:click={onClickQueryTag}/>
                                                    {/if}
                                                {/if}
                                            {/each}

                                            {#if tags.length > ShowTagLimitCount}
                                                {#if !isShowAllTag}
                                                <span class="show-all-tag-button"
                                                      on:click={onClickShowAllTag}>のこり {tags.length - ShowTagLimitCount}
                                                    件のタグをすべて表示</span>
                                                {/if}
                                            {/if}


                                        </div>

                                    </fieldset>
                                </div>
                                <div class="row button-row">
                                    <ButtonView isPrimary={true} text="検索" fontAwesomeIcon="search"
                                                on:click={jumpSearchUrl}/>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div class="binaries-area">
                        <h2>バイナリ一覧</h2>

                        <TipsMessageAreaView>
                            アプリ名や、アイコンをクリックすると、バイナリの詳細画面を開くことができます
                        </TipsMessageAreaView>

                        <BinaryListView
                                space={space}
                                app={app}
                                filterMap={searchFilterMap}
                                on:update={onUpdate}
                        />


                    </div>

                    {#if SpaceUserTable.AuthorityType.hasManage(space.most_strong_authority_type)}
                        <div class="app-manage-area">
                            <AppManageView app={app}/>

                        </div>
                    {/if}

                </div>


            </ValueSlotView>


        </LoadingContentView>


    </SpaceLoadView>

</div>


<style lang="scss">

    .app-page {


        .app-area {
            display: flex;

            .page-title {
                flex-grow: 1;
                margin-bottom: 60px;

                .information-area {
                    margin-top: 30px;
                    font-size: 0.75em;
                }

            }


        }

        .query-area {
            //margin-top: 60px;

            .query-content {
                .row {
                    .tag-area {
                        display: flex;
                        gap: 8px;
                        flex-wrap: wrap;

                        .show-all-tag-button {
                            font-size: 0.5em;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                    }

                    &.button-row {
                        margin-top: 60px;
                    }
                }
            }

        }

        .binaries-area {
            margin-top: 60px;


        }

        .app-manage-area {
            margin-top: 60px;
        }

        .qr-code-area {
            margin-top: 60px;
        }
    }
</style>